import { z } from 'zod';
import { selectedItemSchema } from './priced-item';

export const paymentItemDataSchema = z.object({
  paymentId: z.string(),
  amount: z.string(),
  paymentDate: z.string(),
  paymentType: z.enum(["contract", "product"]),
  paymentMethod: z.enum(["cash", "NMI"]),
});

export type PaymentItemData = z.infer<typeof paymentItemDataSchema>;
